module.exports = __webpack_public_path__ + "img/4c09e5edec3d69f31e4fbc1305f6294d.png";